module.exports = __webpack_public_path__ + "static/img/231.2110e3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200518/231.jpg
// module id = yhM3
// module chunks = 0